import type { SVGProps } from 'react'

export const Funnel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="80"
    viewBox="0 0 81 80"
    width="81"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5 6C8.5 3.79086 10.2909 2 12.5 2H22.5C24.7091 2 26.5 3.79086 26.5 6V68C26.5 70.2091 24.7091 72 22.5 72H12.5C10.2909 72 8.5 70.2091 8.5 68V6Z"
      fill="url(#paint0_linear_2924_502)"
    />
    <path
      d="M31.5 17H49.5V68C49.5 70.2091 47.7091 72 45.5 72H35.5C33.2909 72 31.5 70.2091 31.5 68V17Z"
      fill="url(#paint1_linear_2924_502)"
    />
    <path
      d="M31.5 6C31.5 3.79086 33.2909 2 35.5 2H45.5C47.7091 2 49.5 3.79086 49.5 6V17H31.5V6Z"
      fill="url(#paint2_linear_2924_502)"
    />
    <path
      d="M54.5 27H72.5V68C72.5 70.2091 70.7091 72 68.5 72H58.5C56.2909 72 54.5 70.2091 54.5 68V27Z"
      fill="url(#paint3_linear_2924_502)"
    />
    <path
      d="M54.5 21C54.5 18.7909 56.2909 17 58.5 17H68.5C70.7091 17 72.5 18.7909 72.5 21V27H54.5V21Z"
      fill="url(#paint4_linear_2924_502)"
    />
    <foreignObject height="76.7767" width="96" x="-7.5" y="11.2233">
      <div
        style={{
          backdropFilter: 'blur(4px)',
          clipPath: 'url(#bgblur_0_2924_502_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="8">
      <mask fill="white" id="path-6-inside-1_2924_502">
        <path d="M8.5 80C4.08172 80 0.5 76.4183 0.5 72V27.2321C0.5 21.4629 6.42104 17.5905 11.7065 19.9029L75.7066 47.9029C78.6184 49.1768 80.5 52.0537 80.5 55.2321V72C80.5 76.4183 76.9183 80 72.5 80H8.5Z" />
      </mask>
      <path
        d="M8.5 80C4.08172 80 0.5 76.4183 0.5 72V27.2321C0.5 21.4629 6.42104 17.5905 11.7065 19.9029L75.7066 47.9029C78.6184 49.1768 80.5 52.0537 80.5 55.2321V72C80.5 76.4183 76.9183 80 72.5 80H8.5Z"
        fill="url(#paint5_linear_2924_502)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint6_angular_2924_502_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-6-inside-1_2924_502)"
      >
        <g transform="matrix(5.50604e-10 0.035 -0.04 5.61882e-09 40.5 45)">
          <foreignObject
            height="2028.57"
            width="2028.57"
            x="-1014.29"
            y="-1014.29"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M75.7066 47.9029L75.5061 48.3609L75.7066 47.9029ZM0.5 72H1V27.2321H0.5H0V72H0.5ZM8.5 80V80.5H72.5V80V79.5H8.5V80ZM80.5 72H81V55.2321H80.5H80V72H80.5ZM75.7066 47.9029L75.907 47.4448L11.907 19.4448L11.7065 19.9029L11.5061 20.3609L75.5061 48.3609L75.7066 47.9029ZM80.5 55.2321H81C81 51.8551 79.0009 48.7984 75.907 47.4448L75.7066 47.9029L75.5061 48.3609C78.236 49.5553 80 52.2524 80 55.2321H80.5ZM72.5 80V80.5C77.1944 80.5 81 76.6944 81 72H80.5H80C80 76.1421 76.6421 79.5 72.5 79.5V80ZM0.5 27.2321H1C1 21.8235 6.55097 18.1931 11.5061 20.3609L11.7065 19.9029L11.907 19.4448C6.29111 16.9879 0 21.1023 0 27.2321H0.5ZM0.5 72H0C0 76.6944 3.80558 80.5 8.5 80.5V80V79.5C4.35786 79.5 1 76.1421 1 72H0.5Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:1.1012081131411833e-06,&#34;m01&#34;:-80.000015258789062,&#34;m02&#34;:80.500015258789062,&#34;m10&#34;:70.000007629394531,&#34;m11&#34;:1.1237641047046054e-05,&#34;m12&#34;:9.9999923706054688},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-6-inside-1_2924_502)"
      />
    </g>
    <mask
      height="40"
      id="mask0_2924_502"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="41"
      x="0"
      y="40"
    >
      <rect
        fill="url(#paint7_linear_2924_502)"
        height="40"
        width="40"
        x="0.5"
        y="40"
      />
    </mask>
    <g mask="url(#mask0_2924_502)">
      <path
        d="M19.4746 72.5C19.0557 72.5 18.7053 72.3589 18.4233 72.0767C18.1411 71.7947 18 71.4443 18 71.0254V61.3783L8.45833 49.2467C8.155 48.8919 8.11278 48.5122 8.33167 48.1075C8.55083 47.7025 8.87722 47.5 9.31083 47.5H31.6892C32.1228 47.5 32.4492 47.7025 32.6683 48.1075C32.8872 48.5122 32.845 48.8919 32.5417 49.2467L23 61.3783V71.0254C23 71.4443 22.8589 71.7947 22.5767 72.0767C22.2947 72.3589 21.9443 72.5 21.5254 72.5H19.4746ZM20.5 61.4808L30.0354 49.3913H10.9646L20.5 61.4808Z"
        fill="url(#paint8_linear_2924_502)"
        opacity="0.9"
      />
    </g>
    <defs>
      <clipPath
        id="bgblur_0_2924_502_clip_path"
        transform="translate(7.5 -11.2233)"
      >
        <path d="M8.5 80C4.08172 80 0.5 76.4183 0.5 72V27.2321C0.5 21.4629 6.42104 17.5905 11.7065 19.9029L75.7066 47.9029C78.6184 49.1768 80.5 52.0537 80.5 55.2321V72C80.5 76.4183 76.9183 80 72.5 80H8.5Z" />
      </clipPath>
      <clipPath id="paint6_angular_2924_502_clip_path">
        <path
          d="M75.7066 47.9029L75.5061 48.3609L75.7066 47.9029ZM0.5 72H1V27.2321H0.5H0V72H0.5ZM8.5 80V80.5H72.5V80V79.5H8.5V80ZM80.5 72H81V55.2321H80.5H80V72H80.5ZM75.7066 47.9029L75.907 47.4448L11.907 19.4448L11.7065 19.9029L11.5061 20.3609L75.5061 48.3609L75.7066 47.9029ZM80.5 55.2321H81C81 51.8551 79.0009 48.7984 75.907 47.4448L75.7066 47.9029L75.5061 48.3609C78.236 49.5553 80 52.2524 80 55.2321H80.5ZM72.5 80V80.5C77.1944 80.5 81 76.6944 81 72H80.5H80C80 76.1421 76.6421 79.5 72.5 79.5V80ZM0.5 27.2321H1C1 21.8235 6.55097 18.1931 11.5061 20.3609L11.7065 19.9029L11.907 19.4448C6.29111 16.9879 0 21.1023 0 27.2321H0.5ZM0.5 72H0C0 76.6944 3.80558 80.5 8.5 80.5V80V79.5C4.35786 79.5 1 76.1421 1 72H0.5Z"
          mask="url(#path-6-inside-1_2924_502)"
        />
      </clipPath>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2924_502"
        x1="17.5"
        x2="17.5"
        y1="2"
        y2="72"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#4691F4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2924_502"
        x1="40.5"
        x2="40.5"
        y1="17"
        y2="72"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#4691F4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_2924_502"
        x1="40.5"
        x2="40.5"
        y1="17"
        y2="2"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#D5E3FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_2924_502"
        x1="63.5"
        x2="63.5"
        y1="27"
        y2="72"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#4691F4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_2924_502"
        x1="63.5"
        x2="63.5"
        y1="27"
        y2="17"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#D5E3FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_2924_502"
        x1="40.5"
        x2="40.5"
        y1="5"
        y2="85"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_2924_502"
        x1="20.5"
        x2="20.5"
        y1="80"
        y2="40"
      >
        <stop stopColor="#D5E3FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint8_linear_2924_502"
        x1="20.5"
        x2="15.5941"
        y1="47.5"
        y2="71.4971"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
)
